import { S3Client, DeleteObjectCommand } from "@aws-sdk/client-s3";

const s3 = new S3Client({
    region: process.env.REACT_APP_AWS_REGION,
    credentials: {
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
    }
})

// export const documentsUpload = async (file, type, typeOfUpload) => {

//     const bucketName =
//         typeOfUpload === "SIGNUP"
//             ? process.env.REACT_APP_S3_BUCKET_NAME
//             : typeOfUpload === "MISP SIGNUP"
//                 ? process.env.REACT_APP_S3_MISP_SIGNUP
//                 : process.env.REACT_APP_S3_BUCKET_NAME_POLICY_DOCUMENT;

//     try {
//         // ✅ Convert Blob to ArrayBuffer to avoid 'getReader' error
//         const arrayBuffer = await file.arrayBuffer();
//         const fileKey = uuidv4()
//         const params = {
//             Bucket: bucketName,
//             Key: fileKey,
//             Body: arrayBuffer,
//             ContentType: type,
//         };
//         const command = new PutObjectCommand(params);
//         await s3.send(command);

//         // ✅ Construct the S3 URL manually
//         const fileURL = `https://${bucketName}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${fileKey}`;
//         return fileURL
//     } catch (e) {
//         console.log(e, 'error')
//     }


// };

export const deleteDocument = async (key, typeOfDelete , action) => {

    const res = await fetch("https://5il6my5wxc.execute-api.ap-south-1.amazonaws.com/Prod/bucketuploadhandler/policydocs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            action: action,
            typeOfAction: typeOfDelete, // SIGNUP or MISP SIGNUP
            key : key,
        }),
    });
    const data = await res.json();
    return data
};

const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64 = reader.result.split(",")[1];
            resolve(base64);
        };
        reader.onerror = (error) => reject(error);
    });
};

export const documentsUpload = async (file, typeOfUpload, action) => {
    const base64File = await fileToBase64(file);
    const res = await fetch("https://5il6my5wxc.execute-api.ap-south-1.amazonaws.com/Prod/bucketuploadhandler/policydocs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            action: action,
            typeOfAction: typeOfUpload, // SIGNUP or MISP SIGNUP
            fileBuffer: base64File,
            contentType: file.type,
        }),
    });

    const data = await res.json();
   return data.url
}



// import AWS from 'aws-sdk';
// import { v4 as uuidv4 } from 'uuid'


// AWS.config.update({
//     accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
//     secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
//     region: process.env.REACT_APP_AWS_REGION
// });

// const s3 = new AWS.S3();


// export const documentsUpload = async (file, type , typeOfUpload) => {
//     const params = {
//         Bucket: typeOfUpload === 'SIGNUP' ? process.env.REACT_APP_S3_BUCKET_NAME : typeOfUpload === 'MISP SIGNUP' ? process.env.REACT_APP_S3_MISP_SIGNUP : process.env.REACT_APP_S3_BUCKET_NAME_POLICY_DOCUMENT,
//         Key: uuidv4(),
//         Body: file,
//         ContentType: type
//     };
//     const response = await s3.upload(params).promise()
//     return response
// }



// export const deleteDocument = async (key) => {
//     try {
//         const params = {
//             Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
//             Key: key
//         };

//         const response = await s3.deleteObject(params).promise();
//         console.log("Document deleted successfully:", response);
//         return response;
//     } catch (error) {
//         console.error("Error deleting document:", error);
//         throw error;
//     }
// };



